import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Select} from '../../../../../../accountManagement/shared/Select'
import {
  selectLocations,
  selectSelectedLocationId,
  setSelectedLocationId,
} from '../../../../../../app-store/PurchaseLinkSlice'
import {Wrapper} from './LocationSelector.styles'

// Replaces the Proposal Tool's Good/Better/Best option tabs
// (ProductCatalogProposalTab) for this flow — instead of switching between
// proposal options, this switches which of the account's locations is
// currently shown in the catalog/order summary. Selecting a location just
// updates selectedLocationId in Redux; usePurchaseLinkLocation reacts to
// that change and lazily fetches the location's Recurly info the first time
// it's selected.
export function LocationSelector() {
  const dispatch = useDispatch()
  const locations = useSelector(selectLocations)
  const selectedLocationId = useSelector(selectSelectedLocationId)

  if (locations.length <= 1) return null

  const options = locations.map(loc => ({
    label: loc.locationName || loc.thryvId,
    value: loc.locationId,
  }))

  return (
    <Wrapper>
      <Select
        label="Location"
        options={options}
        value={selectedLocationId}
        onChange={e => dispatch(setSelectedLocationId(e.target.value))}
      />
    </Wrapper>
  )
}
